module.exports = __webpack_public_path__ + "img/ring.0e428932.svg";